/**
 * Las razones del libro, compuestas a partir del catálogo de módulos.
 *
 * Este archivo **no hay que tocarlo** para agregar una razón: se declara en la entrada
 * del módulo, en `modules.ts`, y aparece acá sola. Antes de esto la unión estaba
 * escrita a mano dentro de `ledger.ts`, así que cada mecanismo nuevo obligaba a editar
 * el núcleo del libro — el archivo donde un bug cuesta más caro.
 *
 * `players.coins` es sólo caché: la verdad son los movimientos de `transactions`, y
 * `reconcile()` los compara. Ver la sección Economía de `docs/ARCHITECTURE.md`.
 */
import { ECONOMY_MODULE_IDS, ECONOMY_MODULES } from "./modules.js";
/**
 * Las que no pertenecen a ningún módulo porque no son juego: las mueve una persona.
 *
 * `grant` reparte monedas a mano (soporte, compensar una caída) y `correction` arregla
 * las consecuencias de un bug. Ninguna exige referencia, porque no hay nada de qué
 * protegerse: no las dispara el cliente.
 */
export const CORE_LEDGER_REASONS = ["grant", "correction"];
export const CORE_REASON_LABELS = {
    grant: "Regalo del staff",
    correction: "Corrección",
};
export const LEDGER_REASONS = [
    ...CORE_LEDGER_REASONS,
    ...ECONOMY_MODULE_IDS.flatMap((id) => ECONOMY_MODULES[id].reasons),
];
export const LEDGER_REASONS_REQUIRING_REF = ECONOMY_MODULE_IDS.flatMap((id) => ECONOMY_MODULES[id].reasonsRequiringRef);
export const LEDGER_REASON_LABELS = Object.assign({}, CORE_REASON_LABELS, ...ECONOMY_MODULE_IDS.map((id) => ECONOMY_MODULES[id].reasonLabels));
const REQUIRES_REF = new Set(LEDGER_REASONS_REQUIRING_REF);
export function isLedgerReason(value) {
    return typeof value === "string" && LEDGER_REASONS.includes(value);
}
/** Si es true, el libro rechaza el movimiento sin `ref`. */
export function requiresRef(reason) {
    return REQUIRES_REF.has(reason);
}
/** Qué módulo escribe esta razón, o undefined si es del núcleo. */
export function moduleForReason(reason) {
    return ECONOMY_MODULE_IDS.find((id) => ECONOMY_MODULES[id].reasons.includes(reason));
}
/** Para el historial. Cae al id crudo antes que mostrar un hueco. */
export function reasonLabel(reason) {
    return isLedgerReason(reason) ? LEDGER_REASON_LABELS[reason] : reason;
}
//# sourceMappingURL=reasons.js.map